import React from "react";
import Tooltip from "components/design-system/tooltip";

interface IncentivizedReviewTagProps {
  isIncentivized: boolean;
  className?: string;
}

const IncentivizedReviewTag: React.FC<IncentivizedReviewTagProps> = ({ isIncentivized, className = "" }) => {
  if (!isIncentivized) return null;

  const tooltipContent = (
    <div className="w-56 px-3 py-4 text-center">
      Customer received incentive for providing a review (membership discount, payment, sweepstakes entry)
    </div>
  );

  return (
    <div className={`flex gap-2 items-center ${className}`}>
      <span className="bold text-darkGray">Incentivized</span>
      <Tooltip className="ml-1" tooltipContent={tooltipContent} />
    </div>
  );
};

export default IncentivizedReviewTag;
